<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">兑换码管理</div>
<!--          <span class="m-title-s">对app内容购买兑换新增、编辑等操作</span>-->
        </div>
        <div class="m-table-btn">
          <div class="m-total">
            <div class="m-total-item">
              <div>兑换码总数：{{ allNumber }} 份</div>
            </div>
            <div class="m-total-item">
              <div>未兑换数：{{ notNumber }} 份</div>
            </div>
            <div class="m-total-item">
              <div>已兑换数：{{ okNumber }} 份</div>
            </div>
            <div class="m-total-item">
              <div style="color: #ff4d51; display: flex; align-items: center;">
                输入错误锁定：{{ errorUserNumber }} 人
                <el-button @click="openErrorUserList" type="info" size="mini" style="margin-left: 15px;" plain>查看</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-container>
      <div class="m-search-wrap">
        <el-form :inline="true" :model="searchForm" ref="searchForm">
          <el-form-item label="省-合作商:" size="mini">
            <el-select v-model="searchForm.proviceCoopId" filterable placeholder="请选择" @change="changeProvice">
              <el-option
                v-for="(item, index) in proviceCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市-合作商:" size="mini">
            <el-select v-model="searchForm.cooperatorId" filterable placeholder="请选择" @change="changeCoop">
              <el-option
                v-for="(item, index) in coopList"
                :key="index"
                :label="item.cooperatorName + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="团队长:" size="mini">
            <el-select v-model="searchForm.teamId" filterable placeholder="请选择"
                       :disabled="searchForm.cooperatorId === ''" v-loading="teamLoading" @change="changeTeam">
              <el-option
                v-for="(item, index) in teamCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员:" size="mini">
            <el-select v-model="searchForm.salesmanId" filterable placeholder="请选择" :disabled="searchForm.teamId === ''" v-loading="salesmanLoading">
              <el-option
                v-for="(item, index) in salesmanCoopList"
                :key="index"
                :label="item.label + '-' + item.phone"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="兑换状态:" size="mini">
            <el-select v-model="searchForm.status" filterable placeholder="请选择">
              <el-option  label="已兑换" value="1"></el-option>
              <el-option  label="未兑换" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间范围:" size="mini">
            <el-date-picker
              v-model="pickerTime"
              type="datetimerange"
              :default-time="['00:00:00','23:59:59']"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onPickerChange">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="兑换码:" size="mini">
            <el-input type="text" size="mini" v-model="searchForm.exchangeCode"  placeholder="搜索标题" />
          </el-form-item>
          <el-form-item style="margin-left: 30px;" size="mini">
            <el-button type="primary" size="mini" @click="search()">搜索</el-button>
            <el-button type="primary" size="mini" plain @click="resetForm()">重置</el-button>
            <el-button type="success" @click="exportSearchData" plain size="mini" style="margin-left: 20px;">导出数据</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>兑换码列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="mini">新增</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="mini">
          <el-table-column prop="exchangeCode" label="兑换码"></el-table-column>
          <el-table-column prop="status" label="兑换状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '1'" size="mini" type="success">已兑换</el-tag>
              <el-tag v-else size="mini" type="info">未兑换</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="provinceCooperatorId" label="所属省" align="center"></el-table-column>
          <el-table-column prop="cooperatorId" label="所属市" align="center"></el-table-column>
          <el-table-column prop="teamId" label="所属团队" align="center"></el-table-column>
          <el-table-column prop="salesmanId" label="业务员" align="center"></el-table-column>
          <el-table-column prop="exchangeUserId" label="兑换用户" width="100" align="center"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="370px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" ref="form" :rules="rules" label-width="100px">
            <el-form-item label="省-合作商:" prop="proviceCoopId" size="mini">
              <el-select v-model="form.proviceCoopId" filterable placeholder="请选择-省-合作商" @change="changeProviceForm">
                <el-option
                  v-for="(item, index) in proviceCoopList"
                  :key="index"
                  :label="item.label + '-' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市-合作商:" prop="cooperatorId" size="mini">
              <el-select v-model="form.cooperatorId" filterable placeholder="请选择-市-合作商" @change="changeCoopForm">
                <el-option
                  v-for="(item, index) in coopList"
                  :key="index"
                  :label="item.cooperatorName + '-' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="团队长:" prop="teamId" size="mini">
              <el-select v-model="form.teamId" filterable placeholder="请选择-团队长"
                         :disabled="form.cooperatorId === ''" v-loading="teamLoading" @change="changeTeamForm">
                <el-option
                  v-for="(item, index) in teamCoopList"
                  :key="index"
                  :label="item.label + '-' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员:" prop="salesmanId" size="mini">
              <el-select v-model="form.salesmanId" filterable placeholder="请选择-业务员" :disabled="form.teamId === ''" v-loading="salesmanLoading">
                <el-option
                  v-for="(item, index) in salesmanCoopList"
                  :key="index"
                  :label="item.label + '-' + item.phone"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生成数量: " prop="number" size="mini">
              <el-input v-model="form.number" type="number" placeholder="输入生成数量"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false" size="mini">取 消</el-button>
          <el-button type="primary" @click="submit()" size="mini">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="错误锁定用户列表" :visible.sync="openErrorUserListState" @close='closeErrorUserDialog' width="1600px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <div style="display: flex; align-items: center; justify-content: center;padding: 0 0 10px 0;">
            <div style="font-size: 14px;">
              搜索用户电话：
            </div>
            <div style="width: 200px;">
              <el-input v-model="searchErrorUser" type="text" size="mini" placeholder="输入电话搜索"/>
            </div>
          </div>
          <el-table :data="errorUserList.filter(data => !searchErrorUser || data.phone.toLowerCase().includes(searchErrorUser.toLowerCase()))"
                    style="width: 100%;margin-bottom: 20px;" border size="mini">
            <el-table-column prop="phone" label="电话" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="nickname" label="用户昵称" width=""></el-table-column>
            <el-table-column prop="cityName" label="用户地区" width=""></el-table-column>
            <el-table-column prop="cooperatorName" label="所属服务商" width=""></el-table-column>
            <el-table-column prop="teamName" label="所属团队长" width=""></el-table-column>
            <el-table-column prop="salesmanName" label="所属业务员" width=""></el-table-column>
            <el-table-column prop="loginIp" label="登录ip" width="130" align="center"></el-table-column>
            <el-table-column prop="loginDate" label="登录时间" width="" align="center"></el-table-column>
            <el-table-column prop="createDate" label="创建时间" width="" align="center"></el-table-column>
            <el-table-column prop="updateDate" label="修改时间" width="" align="center"></el-table-column>
            <el-table-column label="操作" width="90" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="restoreUser(scope.row.id, scope.row.phone)" plain>恢复</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openErrorUserListState = false" size="mini" type="primary">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import excelUtil from '../utils/ExcelUtils'
export default {
  name: 'exchangeCode',
  data () {
    return {
      openText: '新增兑换码',
      openState: false,
      openErrorUserListState: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      teamLoading: false,
      salesmanLoading: false,
      errorUserList: [], // 输入错误5次用户列表
      errorUserNumber: 0, // 输入错误5次人数
      searchErrorUser: '',
      coopList: [], // 市级合作商选项
      proviceCoopList: [], // 省级合作商选项
      teamCoopList: [], // 团队长选项
      salesmanCoopList: [], // 业务员选项
      allNumber: 0,
      notNumber: 0,
      okNumber: 0,
      list: [],
      total: 0,
      searchForm: {
        status: '',
        exchangeCode: '',
        proviceCoopId: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      },
      form: {
        proviceCoopId: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        number: ''
      },
      pickerTime: '',
      rules: {
        cooperatorId: [
          { required: true, message: '请选择所属合作商', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入生成数量', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    useExportUtil (data) {
      const initColumn = [
        {
          title: '兑换码',
          dataIndex: 'exchangeCode',
          key: 'exchangeCode',
          className: 'text-monospace'
        },
        {
          title: '所属省',
          dataIndex: 'provinceCooperatorId',
          key: 'provinceCooperatorId'
        },
        {
          title: '所属市',
          dataIndex: 'cooperatorId',
          key: 'cooperatorId'
        },
        {
          title: '所属团队',
          dataIndex: 'teamId',
          key: 'teamId'
        },
        {
          title: '所属业务员',
          dataIndex: 'salesmanId',
          key: 'salesmanId'
        }
      ]
      excelUtil.exportExcel(initColumn, data, '兑换码列表.xlsx')
    },
    onPickerChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.searchForm.startDate = startDate.getFullYear() + '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) + '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.searchForm.endDate = endDate.getFullYear() + '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) + '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.listData()
    },
    closeDialog () {
      this.form = {
        id: '',
        proviceCoopId: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        number: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
      this.$refs.form.clearValidate()
      this.resetForm()
    },
    search () {
      this.searchForm.pageNo = 1
      this.listData()
    },
    resetForm () {
      this.searchForm = {
        status: '',
        exchangeCode: '',
        proviceCoopId: '',
        cooperatorId: '',
        teamId: '',
        salesmanId: '',
        startDate: '',
        endDate: '',
        pageNo: 1
      }
      this.pickerTime = ''
      this.listData()
      this.changeProvice()
    },
    openPopup () {
      this.openState = true
    },
    openErrorUserList () {
      this.openErrorUserListState = true
    },
    closeErrorUserDialog () {
      this.searchErrorUser = ''
      // this.errorUserList = []
    },
    restoreUser (userId, phone) {
      let _this = this
      this.$confirm('提交后用户 ' + phone + ' 的错误锁定将恢复初始', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/user/exchange/restoreUserErrorNum', {userId: userId})
          .then((res) => {
            if (res.status === 200) {
              _this.errorUserList = []
              _this.errorUserNumber = 0
              _this.errorUserNumberData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出当前查询条件的数据
    exportSearchData () {
      let _this = this
      // if (_this.searchForm.startDate === '' || _this.searchForm.endDate === '') {
      //   _this.$message.error('请选择查询日期再导出数据')
      //   return
      // }
      _this.isLoading = true
      this.$axios.post('/user/exchange/exportSearchDataPayList', _this.searchForm)
        .then((res) => {
          if (res.data !== null) {
            if (res.data.length > 0) {
              let list = []
              for (let i = 0; i < res.data.length; i++) {
                list.push(res.data[i])
                list[i].provinceCooperatorId = list[i].provinceCooperatorId != null && list[i].provinceCooperatorId !== '' ? list[i].provinceCooperatorId : '无'
                list[i].cooperatorId = list[i].cooperatorId != null && list[i].cooperatorId !== '' ? list[i].cooperatorId : '无'
                list[i].teamId = list[i].teamId != null && list[i].teamId !== '' ? list[i].teamId : '无'
                list[i].salesmanId = list[i].salesmanId != null && list[i].salesmanId !== '' ? list[i].salesmanId : '无'
              }
              _this.useExportUtil(list) // 执行导出数据
            }
          }
          _this.exportSearchDataList = res.data
          _this.isLoading = false
        })
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          this.$axios.post('/user/exchange/add', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.listData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id) {
      let _this = this
      this.$messageBox.confirm('此操作将删除当前兑换码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/user/exchange/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/user/exchange/list', this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.allNumber = res.data.total
          _this.isLoading = false
          _this.notNumberData()
          _this.okNumberData()
        })
    },
    // 兑换码数量，未兑换
    notNumberData () {
      let _this = this
      if (this.searchForm.status !== '' && this.searchForm.status !== '0') {
        this.notNumber = 0
        return
      }
      let params = {
        status: '0',
        exchangeCode: this.searchForm.exchangeCode,
        proviceCoopId: this.searchForm.proviceCoopId,
        cooperatorId: this.searchForm.cooperatorId,
        teamId: this.searchForm.teamId,
        salesmanId: this.searchForm.salesmanId,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        pageNo: 1
      }
      this.$axios.post('/user/exchange/list', params)
        .then((res) => {
          _this.notNumber = res.data.total
        })
    },
    // 兑换码数量，已经兑换
    okNumberData () {
      let _this = this
      if (this.searchForm.status !== '' && this.searchForm.status !== '1') {
        this.okNumber = 0
        return
      }
      let params = {
        status: '1',
        exchangeCode: this.searchForm.exchangeCode,
        proviceCoopId: this.searchForm.proviceCoopId,
        cooperatorId: this.searchForm.cooperatorId,
        teamId: this.searchForm.teamId,
        salesmanId: this.searchForm.salesmanId,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        pageNo: 1
      }
      this.$axios.post('/user/exchange/list', params)
        .then((res) => {
          _this.okNumber = res.data.total
        })
    },
    errorUserNumberData () {
      let _this = this
      this.$axios.post('/user/exchange/errorUserNumber')
        .then((res) => {
          _this.errorUserList = res.data.errorUserList
          _this.errorUserNumber = res.data.errorUserNumber
        })
    },
    // 省级变化时，市，团，员，全清空
    changeProviceForm () {
      this.form.cooperatorId = ''
      this.form.teamId = ''
      this.form.salesmanId = ''
      this.coopList = []
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.listCoopData(this.form.proviceCoopId)
    },
    // 市级变化时，团，员，清空
    changeCoopForm () {
      this.form.teamId = ''
      this.form.salesmanId = ''
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.teamCoopData(this.form.cooperatorId)
    },
    // 团级变化时，员，清空
    changeTeamForm () {
      this.form.salesmanId = ''
      this.salesmanCoopList = []
      this.salesmanCoopData(this.form.teamId)
    },
    // 省级变化时，市，团，员，全清空
    changeProvice () {
      this.searchForm.cooperatorId = ''
      this.searchForm.teamId = ''
      this.searchForm.salesmanId = ''
      this.coopList = []
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.listCoopData(this.searchForm.proviceCoopId)
    },
    // 市级变化时，团，员，清空
    changeCoop () {
      this.searchForm.teamId = ''
      this.searchForm.salesmanId = ''
      this.teamCoopList = []
      this.salesmanCoopList = []
      this.teamCoopData(this.searchForm.cooperatorId)
    },
    // 团级变化时，员，清空
    changeTeam () {
      this.searchForm.salesmanId = ''
      this.salesmanCoopList = []
      this.salesmanCoopData(this.searchForm.teamId)
    },
    // 省级合作商下拉选项
    proviceCoopData () {
      this.$axios.post('/dropDownList/proviceCoopList')
        .then((res) => {
          this.proviceCoopList = res.data
        })
    },
    // 市级合作商下拉选项
    listCoopData (proviceCoopId) {
      this.$axios.post('/dropDownList/coopList', {proviceCoopId: proviceCoopId})
        .then((res) => {
          this.coopList = res.data
        })
    },
    // 团队长下拉选项
    teamCoopData (cooperatorId) {
      this.teamLoading = true
      this.$axios.post('/dropDownList/teamCoopList', {cooperatorId: cooperatorId})
        .then((res) => {
          this.teamCoopList = res.data
          this.teamLoading = false
        })
    },
    // 业务员下拉选项
    salesmanCoopData (teamId) {
      this.salesmanLoading = true
      this.$axios.post('/dropDownList/salesmanCoopList', {teamId: teamId})
        .then((res) => {
          this.salesmanCoopList = res.data
          this.salesmanLoading = false
        })
    }
  },
  mounted () {
    this.listData()
    this.listCoopData()
    this.proviceCoopData()
    this.errorUserNumberData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/ExchangeCode.vue